import { normalize } from "normalizr";
import { get } from "../api/status-page-api";
import { externalServicesIncidentsSchema } from "./status-page-schema";
import { SET_EXTERNAL_SERVICES_INCIDENT, SET_EXTERNAL_SERVICES_INCIDENTS } from "./status-page-mutations";
export const LOAD_EXTERNAL_SERVICES_STATUS = "LOAD_EXTERNAL_SERVICES_STATUS";
const actions = {
  [LOAD_EXTERNAL_SERVICES_STATUS]: async (context, service) => {
    const {
      externalServices
    } = await get();
    const {
      entities,
      result
    } = normalize(externalServices, [externalServicesIncidentsSchema]);
    const mutationToCall = service ? SET_EXTERNAL_SERVICES_INCIDENT : SET_EXTERNAL_SERVICES_INCIDENTS;
    context.commit(mutationToCall, {
      externalServicesIncidents: {
        byId: entities.externalServicesIncidents || {},
        allIds: result
      },
      service
    });
  }
};
export default actions;